export const DRAFTS_OR_VALUE_GROUP_EDITORS = {
    agreementName: 'text',
    clientName: 'text',
    contactName: 'text',
    effectiveDate: 'date',
    lastUpdatedAt: 'date',
    netTerms: 'integer'
};
export const draftsOrValueGroupFields = (t)=>({
        agreementName: {
            editor: DRAFTS_OR_VALUE_GROUP_EDITORS.agreementName,
            label: t.agreementNameLabel()
        },
        clientName: {
            editor: DRAFTS_OR_VALUE_GROUP_EDITORS.clientName,
            label: t.clientNameLabel()
        },
        contactName: {
            editor: DRAFTS_OR_VALUE_GROUP_EDITORS.contactName,
            label: t.recipientNameLabel()
        },
        effectiveDate: {
            editor: DRAFTS_OR_VALUE_GROUP_EDITORS.effectiveDate,
            label: t.effectiveDateLabel()
        },
        lastUpdatedAt: {
            editor: DRAFTS_OR_VALUE_GROUP_EDITORS.lastUpdatedAt,
            label: t.lastUpdatedLabel()
        },
        netTerms: {
            editor: DRAFTS_OR_VALUE_GROUP_EDITORS.netTerms,
            label: t.netDaysLabel(),
            suffix: t.netDaysSuffix(),
            validationError: t.singleValueValidationError()
        }
    });
export const draftsOrValueGroupTexts = (t)=>({
        apply: t.applyButton(),
        connector: {
            and: t.andConnector(),
            or: t.orConnector()
        }
    });
